import { createContext } from 'react';

export type Selected = {
  lineId: string;   // e.g. "S1"
  routeId: string;  // e.g. "7624"
};

type ContextType = {
  selected: Selected | null;
  setSelected: (sel: Selected | null) => void;
};

export const Context = createContext({} as ContextType);
